import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { Injectable } from '@angular/core';
import { MeshComponentUtils } from './util/mesh-component-utils';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';

@Injectable({ providedIn: 'root' })
export class DynamicConnectionCreator {

  constructor(private _meshComponentUtils: MeshComponentUtils) {
  }

  public createConnectionsForDynamicGivingConnection(givingArticle: ArticleContainer, isInvertedDirection: boolean): Connection[] {
    const givingMeshes: Connection[] = new Array<Connection>();
    for (const connection of ArticleUsageUtils.connections(givingArticle.articleUsage)) {
      for (const identity of connection.givingAreaIds) {
        if (identity.articleUsageId === givingArticle.articleGUID && !givingArticle.findConnectionByName(identity.metaElementName)) {
          givingMeshes.push(this._meshComponentUtils.addGivingMeshToContainer(givingArticle, connection.acceptingAreaId,
            identity.metaElementName, isInvertedDirection));
        }
      }
    }
    return givingMeshes;
  }
}
